import {
  getExternalContactDetailService,
  getInternalContactDetailService,
  getRoomDetailService as getWecomRoomDetailService,
  toggleConversationStatusService as toggleWecomConversationStatusService,
} from "@/pages/channel-chat/channel-chat-list/wecom-chat/services";
import {
  getContactDetailService,
  getRoomDetailService as getWechatRoomDetailService,
  toggleConversationStatusService as toggleWechatConversationStatusService,
} from "@/pages/channel-chat/channel-chat-list/wechat-chat/services";
import {
  getContactDetailService as getWhatsAppContactDetailService,
  toggleConversationStatusService as toggleWhatsAppConversationStatusService,
} from "@/pages/channel-chat/channel-chat-list/whatsapp-chat/services";
import {
  ChannelTypeEnum,
  MailConversationDataType,
  sortMemberList,
  WechatContact,
  WechatContactType,
  WechatConversationDataType,
  WechatRoom,
  WecomContactType,
  WecomConversationDataType,
  WecomInnerContact,
  WecomOuterContact,
  WecomRoom,
  WhatsAppContact,
  WhatsAppContactType,
  WhatsAppConversationDataType,
} from "@packages/chat-sdk";
import { ResponseCode, routerPath } from "@/constants";
import {
  wecomChatPersistentStoreActions,
  wecomChatStoreActions,
} from "@/pages/channel-chat/channel-chat-list/wecom-chat/store";
import {
  wechatChatPersistentStoreActions,
  wechatChatStoreActions,
} from "@/pages/channel-chat/channel-chat-list/wechat-chat/store";
import {
  whatsappChatPersistentStoreActions,
  whatsappChatStoreActions,
} from "@/pages/channel-chat/channel-chat-list/whatsapp-chat/store";
import { damselfishPersistentStoreActions } from "@/store";
import { history } from "@umijs/max";
import {
  mailChatPersistentStoreActions,
  mailChatStoreActions,
} from "@/pages/channel-chat/channel-chat-list/email/store";

const readConversation = async (
  fromUserId: string,
  chatId: string,
  channelType: ChannelTypeEnum
) => {
  if (channelType === ChannelTypeEnum.Wecom) {
    const res = await toggleWecomConversationStatusService(fromUserId, {
      chat_id: chatId,
      unread: 0,
    });
    if (res?.code === ResponseCode.Success) {
      window.electronApi?.sendWindowMessage({
        type: "readConversation",
        payload: {
          chatId,
          chatType: channelType,
        },
      });
    }
  } else if (channelType === ChannelTypeEnum.Wechat) {
    const res = await toggleWechatConversationStatusService(fromUserId, {
      chat_id: chatId,
      unread: 0,
    });
    if (res?.code === ResponseCode.Success) {
      window.electronApi?.sendWindowMessage({
        type: "readConversation",
        payload: {
          chatId,
          chatType: channelType,
        },
      });
    }
  } else if (channelType === ChannelTypeEnum.WhatsApp) {
    const res = await toggleWhatsAppConversationStatusService(fromUserId, {
      chat_id: chatId,
      unread: 0,
    });
    if (res?.code === ResponseCode.Success) {
      window.electronApi?.sendWindowMessage({
        type: "readConversation",
        payload: {
          chatId,
          chatType: channelType,
        },
      });
    }
  }
};

const handleSelectWecomConversation = async (
  conversation: WecomConversationDataType
) => {
  wecomChatStoreActions.setSelectedConversation(conversation);
  let contact: (WecomOuterContact | WecomInnerContact) | undefined;
  let room: WecomRoom | undefined;
  if (conversation?.chat_type === WecomContactType.OUTER_SINGLE) {
    const res = await getExternalContactDetailService(
      conversation?.another_id!,
      conversation?.from_user_id!
    );
    if (res?.code === ResponseCode.Success) {
      contact = res?.data;
    }
  } else if (conversation?.chat_type === WecomContactType.INNER_SINGLE) {
    const res = await getInternalContactDetailService(
      conversation?.another_id!,
      conversation?.from_user_id!
    );
    if (res?.code === ResponseCode.Success) {
      contact = res?.data;
    }
  } else if (
    conversation?.chat_type === WecomContactType.OUTER_ROOM ||
    conversation?.chat_type === WecomContactType.INNER_ROOM
  ) {
    const res = await getWecomRoomDetailService({
      roomId: conversation?.another_id!,
      userId: conversation?.from_user_id!,
    });
    if (res?.code === ResponseCode.Success) {
      room = {
        ...res?.data,
        id: conversation?.chat_id,
        from_user_id: conversation?.from_user_id!,
        member_list: sortMemberList(
          res?.data?.member_list,
          res?.data?.room_owner_id
        ),
      };
    }
  }
  wecomChatStoreActions.setSelectedConversation({
    ...conversation,
    room,
    contact,
    chat_type: conversation?.chat_type!,
  });
};

const handleSelectWechatConversation = async (
  conversation: WechatConversationDataType
) => {
  wechatChatStoreActions.setSelectedConversation(conversation);
  let contact: WechatContact | undefined;
  let room: WechatRoom | undefined;
  if (conversation?.chat_type === WechatContactType.SINGLE) {
    const res = await getContactDetailService(
      conversation?.another_id!,
      conversation?.from_user_id!
    );
    if (res?.code === ResponseCode.Success) {
      contact = res?.data;
    }
  } else if (conversation?.chat_type === WechatContactType.ROOM) {
    const res = await getWechatRoomDetailService({
      roomId: conversation?.another_id!,
      userId: conversation?.from_user_id!,
    });
    if (res?.code === ResponseCode.Success) {
      room = {
        ...res?.data,
        id: conversation?.chat_id,
        from_user_id: conversation?.from_user_id!,
      };
    }
  }

  wechatChatStoreActions.setSelectedConversation({
    ...conversation,
    room,
    contact,
    chat_type: conversation?.chat_type!,
  });
};

const handleSelectWhatsAppConversation = async (
  conversation: WhatsAppConversationDataType
) => {
  whatsappChatStoreActions.setSelectedConversation(conversation);
  let contact: WhatsAppContact | undefined;
  const res = await getWhatsAppContactDetailService(
    conversation?.another_id!,
    conversation?.from_user_id!
  );
  if (res?.code === ResponseCode.Success) {
    contact = res?.data;
  }

  whatsappChatStoreActions.setSelectedConversation({
    ...conversation,
    contact,
    chat_type: conversation?.chat_type!,
  });
};

const handleSelectMailConversation = async (
  conversation: MailConversationDataType
) => {
  mailChatStoreActions.setSelectedConversation(conversation);
};

const selectConversation = (
  conversation:
    | WecomConversationDataType
    | WechatConversationDataType
    | WhatsAppConversationDataType
    | MailConversationDataType,
  channelType: ChannelTypeEnum,
  needRead = true
) => {
  damselfishPersistentStoreActions.setTeamId(conversation?.team_id);
  if (needRead) {
    readConversation(
      conversation?.from_user_id!,
      conversation?.chat_id,
      channelType
    );
  }
  if (channelType === ChannelTypeEnum.Wecom) {
    wecomChatPersistentStoreActions.selectConversation({
      chatId: conversation?.chat_id,
      chatType: (conversation as WecomConversationDataType)
        ?.chat_type as WecomContactType,
    });
    handleSelectWecomConversation(conversation as WecomConversationDataType);
    if (window.location.pathname !== routerPath.CHANNEL_CHAT_LIST_WECOM_CHAT) {
      damselfishPersistentStoreActions.setChannelType(channelType);
      history.push(routerPath.CHANNEL_CHAT_LIST_WECOM_CHAT);
    }
  } else if (channelType === ChannelTypeEnum.Wechat) {
    wechatChatPersistentStoreActions.selectConversation({
      fromUserId: conversation?.from_user_id,
      toUserId: conversation?.another_id,
      chatType: (conversation as WechatConversationDataType)
        ?.chat_type as WechatContactType,
    });
    handleSelectWechatConversation(conversation as WechatConversationDataType);
    if (window.location.pathname !== routerPath.CHANNEL_CHAT_LIST_WECHAT_CHAT) {
      damselfishPersistentStoreActions.setChannelType(channelType);
      history.push(routerPath.CHANNEL_CHAT_LIST_WECHAT_CHAT);
    }
  } else if (channelType === ChannelTypeEnum.WhatsApp) {
    whatsappChatPersistentStoreActions.selectConversation({
      fromUserId: conversation?.from_user_id,
      toUserId: conversation?.another_id,
      chatType: (conversation as WhatsAppConversationDataType)
        ?.chat_type as WhatsAppContactType,
    });
    handleSelectWhatsAppConversation(
      conversation as WhatsAppConversationDataType
    );
    if (
      window.location.pathname !== routerPath.CHANNEL_CHAT_LIST_WHATSAPP_CHAT
    ) {
      damselfishPersistentStoreActions.setChannelType(channelType);
      history.push(routerPath.CHANNEL_CHAT_LIST_WHATSAPP_CHAT);
    }
  } else if (channelType === ChannelTypeEnum.Email) {
    mailChatPersistentStoreActions.selectConversation({
      fromUserId: conversation.from_user_id,
      toUserId: conversation.another_id,
      chatId: conversation.chat_id,
    });
    handleSelectMailConversation(conversation as MailConversationDataType);
    if (window.location.pathname !== routerPath.CHANNEL_CHAT_LIST_MAIL_CHAT) {
      damselfishPersistentStoreActions.setChannelType(channelType);
      history.push(routerPath.CHANNEL_CHAT_LIST_MAIL_CHAT);
    }
  }
};
const channelActions = { readConversation, selectConversation };
export default channelActions;
